import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home').then((m) => m.HomeComponent),
  },

  //Brands
  {
    path: 'marcas',
    loadComponent: () => import('./brands/home/home').then((m) => m.Home),
  },
  {
    path: 'marcas/:slugBrand',
    loadComponent: () => import('./brands/detail/detail').then((m) => m.Detail),
  },

  //New Equipment
  {
    path: 'equipos',
    loadComponent: () => import('./new-equipment/home/home').then((m) => m.Home),
  },
  {
    path: 'equipos/:slugCategory',
    loadComponent: () => import('./new-equipment/category/category').then((m) => m.Category),
  },
  {
    path: 'equipos/:slugCategory/:slugSubcategory',
    loadComponent: () =>
      import('./new-equipment/subcategory/subcategory').then((m) => m.Subcategory),
  },
  {
    path: 'equipos/:slugCategory/:slugSubcategory/:slugBrand',
    loadComponent: () =>
      import('./new-equipment/subcategory-brand/subcategory-brand').then((m) => m.SubcategoryBrand),
  },
  {
    path: 'equipos/:slugCategory/:slugSubcategory/:slugBrand/:slugEquipment',
    loadComponent: () =>
      import('./new-equipment/equipment/equipment').then((m) => m.EquipmentComponent),
  },

  //Branches
  {
    path: 'sucursales',
    loadComponent: () => import('./branches/home/home').then((m) => m.Home),
  },
  {
    path: 'sucursales/:slugBranch',
    loadComponent: () => import('./branches/detail/detail').then((m) => m.Detail),
  },

  //Legals
  {
    path: 'legales/:slugLegal',
    loadComponent: () => import('./legals/legals').then((m) => m.LegalsComponent),
  },
  {
    path: 'validacion',
    loadComponent: () =>
      import('./invoice-validation/invoice-validation').then((m) => m.InvoiceValidation),
  },

  //Blog
  {
    path: 'blog',
    loadComponent: () => import('./blog/home/home').then((m) => m.HomeComponent),
  },
  {
    path: 'blog/:slugPost',
    loadComponent: () => import('./blog/detail/detail').then((m) => m.DetailComponent),
  },

  //Services
  {
    path: 'servicios',
    loadComponent: () => import('./services-view/home/home').then((m) => m.HomeComponent),
  },
  {
    path: 'servicios/:slug',
    loadComponent: () => import('./services-view/solution/solution').then((m) => m.SolutionComponent),
  },

  //Contact
  {
    path: 'contacto',
    loadComponent: () => import('./contact/contact').then((m) => m.Contact),
  },

  //Spare Parts
  {
    path: 'refacciones',
    loadComponent: () => import('./spare-parts/home/home').then((m) => m.Home),
  },
  {
    path: 'refacciones/:slugCategory',
    loadComponent: () => import('./spare-parts/category/category').then((m) => m.CategoryComponent),
  },

  //Promotions
  {
    path: 'destacados',
    loadComponent: () => import('./promotions/home/home').then((m) => m.Home),
  },
  {
    path: 'destacados/:detail',
    loadComponent: () => import('./promotions/detail/detail').then((m) => m.Detail),
  },

  //Used Equipment
  {
    path: 'usado',
    loadComponent: () => import('./used-equipment/home/home').then((m) => m.Home),
  },
  {
    path: 'usado/categorias',
    loadComponent: () => import('./used-equipment/categories/categories').then((m) => m.Categories),
  },
  {
    path: 'usado/categorias/:slugCategory',
    loadComponent: () => import('./used-equipment/category/category').then((m) => m.Category),
  },
  {
    path: 'usado/categorias/:slugCategory/:slugSubcategory',
    loadComponent: () =>
      import('./used-equipment/subcategory/subcategory').then((m) => m.Subcategory),
  },
  {
    path: 'usado/categorias/:slugCategory/:slugSubcategory/:economicNumber',
    loadComponent: () => import('./used-equipment/equipment/equipment').then((m) => m.Equipment),
  },

  //Quoters
  {
    path: 'cotizador-mallas',
    loadComponent: () => import('./quote/wired/wired').then((m) => m.Wired),
  },

  //Rent
  {
    path: 'renta',
    loadComponent: () => import('./rent/home/home').then((m) => m.Home),
  },

  //404 Not Found
  //{ path: '404', loadComponent: () => import('./not-found/not-found').then((m) => m.NotFound) },
  { path: '**', loadComponent: () => import('./not-found/not-found').then((m) => m.NotFound) },
];
